import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import Cookies from 'js-cookie';
import { screen } from '../variables';
import Button from './styled-components/Button';

export default function CookieConsent() {
  const [cookieOptIn, setCookieOptIn] = useState(Cookies.get('cookie-opt-in'));

  const optIn = () => {
    setCookieOptIn(true);
    Cookies.set('cookie-opt-in', true, { expires: 90 });
    window.location.reload();
  };

  const optOut = () => {
    setCookieOptIn(false);
    Cookies.set('cookie-opt-in', false, { expires: 90 });
  };

  return (
    cookieOptIn === undefined && (
      <CookieConsentBanner>
        <p>
          Wir nutzen auf dieser Website Cookies. Einige von ihnen sind
          essentiell, während andere uns helfen, diese Website und dadurch Ihre
          Nutzererfahrung zu verbessern. Weitere Informationen finden Sie in der{' '}
          <Link to="/datenschutz">Datenschutzerklärung</Link>.
        </p>
        <Button
          label="Nur essentielle Cookies speichern"
          className="decline"
          small
          alert
          onClick={() => optOut()}
        />
        <Button
          label="Alle speichern"
          className="accept"
          small
          onClick={() => optIn()}
        />
      </CookieConsentBanner>
    )
  );
}

const CookieConsentBanner = styled.div`
  border-radius: 5px;
  padding: 15px;
  background-color: #fff;
  border: 1px solid rgba(0, 0, 0, 0.15);
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.05), 0px 3px 12px rgba(0, 0, 0, 0.1);
  font-size: 18px;
  position: fixed;
  z-index: 1000000;
  bottom: 50px;
  right: 50px;
  margin: auto;
  max-width: 550px;
  display: flex;
  flex-flow: row wrap;
  justify-content: space-between;

  @media (max-width: ${screen.tablet}px) {
    bottom: 16px;
    right: 16px;
    left: 16px;
  }

  p {
    flex: 0 0 100%;
    line-height: 1.5;
    margin-bottom: 20px;

    a {
      display: inline-block;
      color: #13a583;
      text-decoration: none;
      border-bottom: 1px solid rgba(0, 0, 0, 0.1);
    }
  }

  button {
    margin-bottom: 16px;
  }
`;
